import React, { Component } from "react"
import moment from 'moment';
import momentz from 'moment-timezone';
import store from "./store/index";
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import date from "../node_modules/date-and-time"
import { RadioGroup, RadioButton } from 'react-radio-buttons';
import Row from 'react-bootstrap/Form'
import './index.css';
import { updateTimeSettingsOneByOne } from "./actions/index";
import { updateExactTimeSettingsOneByOne } from "./actions/index";
import { update_Is_Exact_Time_One_By_One } from "./actions/index";

const showSecond = false;
const str = showSecond ? 'HH:mm:ss' : 'HH:mm';

function minutesToHHMM(mins) {
  if (mins < 0) {
    return '00:00'
  }
  let h = Math.floor(mins / 60);
  let m = mins % 60;
  m = m < 10 ? '0' + m : m;
  h = h < 10 ? '0' + h : h;
  return `${h}:${m}`;
}
const spacer = {
  height: '5px'
}

const marginRight = {
  marginRight: '5px'
}

const inlineBlock = {
  display: 'inline-block',
  width: '50%',
  color: 'white',
}



const timerSize = {
  width: '100px'
}
const timerSize1 = {
  width: '100px',
  fontSize: '12px',
  color: '#666',
  paddingLeft: '5px'
}

function getTimeDiffInMins(timeDiff) {
  var hours = parseInt(timeDiff.substring(0, 2))
  var mints = parseInt(timeDiff.substring(3, 5))

  return (hours * 60 + mints)

}



class TimeSetter extends Component {


  constructor(props) {
    super(props);
    this.state = {
      element: this.props.label.toLowerCase(),
      timerSelected: "exact",
      timeInExactTime: null,
      timeinDiff: null
    }


    //const unsubscribe = store.subscribe(handleChange)
    //unsubscribe()
    this.testing = this.testing.bind(this)
    this.testing2 = this.testing2.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleTimeChangeEvent = this.handleTimeChangeEvent.bind(this)
    this.handleTimeChangeEventInDiff = this.handleTimeChangeEventInDiff.bind(this)
    store.subscribe(this.testing2)

  }

  testing2() {
    let exacttime = moment(store.getState().exactTimeSettings[this.state.element], 'HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')
    let difftime = parseInt(this.getTimeDiffInMins(store.getState().timeSettings[this.state.element]))
    let isExact = store.getState().isExactTimeSelected[this.state.element]
    this.setState(
      {
        timeInExactTime: exacttime,
        timeinDiff: difftime,
        timerSelected: isExact
      }
    )
  }

  testing() {
    let raceMoment = moment(store.getState().currentRaceTime, 'YYYYMMDD HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')
    let previousExactValue = this.state.timeInExactTime
    let currentExactValue = raceMoment.subtract(parseInt(this.getTimeDiffInMins(store.getState().timeSettings[this.state.element])), 'minutes')
    let previousDiffValue = this.state.timeinDiff
    let currentDiffValue = parseInt(this.getTimeDiffInMins(store.getState().timeSettings[this.state.element]))
    console.log("Hello 123 previousExactValue:" + previousExactValue + " currentExactValue:" + currentExactValue + " previousDiffValue:" + previousDiffValue + " currentDiffValue:" + currentDiffValue);

    if (previousExactValue !== currentExactValue) {
      console.log(
        'Some deep nested property changed from',
        previousExactValue,
        'to',
        currentExactValue
      )
      this.setState(
        { timeInExactTime: currentExactValue }
      )
    }
    if (previousDiffValue !== currentDiffValue) {
      console.log(
        'Some deep nested property changed from',
        previousDiffValue,
        'to',
        currentDiffValue
      )
      this.setState(
        { timeinDiff: currentDiffValue }
      )
    }
  }

  getTimeDiffInMins(timeDiff) {
    var hours = timeDiff ? parseInt(timeDiff.substring(0, 2)) : 0
    var mints = timeDiff ? parseInt(timeDiff.substring(3, 5)) : 0

    return (hours * 60 + mints)

  }

  handleChange(event) {
    console.log("SDSDSD " + event.target.value);
    let payload = {}
    payload.id = this.props.label.toLowerCase()
    payload.value = event.target.value
    store.dispatch(update_Is_Exact_Time_One_By_One(payload))

    this.setState({
      timerSelected: event.target.value
    });
  }

  handleTimeChangeEvent(value) {
    let raceMoment = "00:00"
    if (value !== null) {
      //console.log("Exact time selected value : " + value);
      raceMoment = moment(value, 'HH:mm').subtract(store.getState().localTimeOffSetToGmt, 'minutes').format("HH:mm")
      //console.log("Exact time selected GMT value : " + raceMoment);
    }

    let payload = {}
    payload.id = this.props.label.toLowerCase()
    payload.value = raceMoment
    store.dispatch(updateExactTimeSettingsOneByOne(payload))

  }
  handleTimeChangeEventInDiff(event) {
    //let timeDiff = moment().tz("Etc/GMT").diff(value,'minutes')
    //console.log("Time in Diff :: " + event.target.value);
    let val = minutesToHHMM(event.target.value)
    let payload = {}
    payload.id = this.props.label.toLowerCase()
    payload.value = val
    store.dispatch(updateTimeSettingsOneByOne(payload))

  }

  getLabel(originalLabel){
    if(originalLabel == 't0gb'){
      return 'T0( UK/Ireland)';
    } else if(originalLabel == 't0anz'){
      return 'T0(ANZ)';
    } else if(originalLabel == 't0oth'){
      return 'T0(OTH)';
    }else{
      return originalLabel.toUpperCase();
    }
  }

  render() {


    var isExactTime = this.state.timerSelected == "exact" ? true : false;

    //console.log("Time DIFF in :: " + this.props.timeDiff + " is Exact Time : " + isExactTime);

    return (
      <div as={Row} className="divMargin1">
        <div as={Row} className="textColor1">
          {this.getLabel(this.props.label)} Options
        </div>
        <form>
          <div style={inlineBlock}>
            <input
              type="radio"
              name="fruit"
              value="exact"
              checked={this.state.timerSelected === "exact"}
              onChange={this.handleChange}
              style={marginRight} />
            Exact time</div>

          <div style={inlineBlock}>
            <div style={timerSize}>
              <TimePicker as={Row}
                format={str}
                disabled={!isExactTime}
                popupStyle={{ width: 300, fontSize: 20 }}
                showSecond={showSecond}
                value={this.state.timeInExactTime}
                defaultValue={moment(store.getState().exactTimeSettings[this.state.element], 'HH:mm').add(store.getState().localTimeOffSetToGmt, 'minutes')}
                className="textpicker"
                id={this.state.element}
                onChange={this.handleTimeChangeEvent}
              />
            </div>
          </div>
          <div style={spacer}></div>
          <div style={inlineBlock}>
            <input
              type="radio"
              name="fruit"
              value="diff"
              checked={this.state.timerSelected === "diff"}
              onChange={this.handleChange}
              style={marginRight} />Minutes before start</div>
          <div style={inlineBlock}>
            <input
              id="timeSetT1"
              type="number"
              style={timerSize1}
              disabled={isExactTime}
              onChange={this.handleTimeChangeEventInDiff}
              value={this.state.timeinDiff}
              defaultValue={parseInt(this.getTimeDiffInMins(store.getState().timeSettings[this.state.element]))} /></div>
        </form>

      </div>
    )
  }
}
export default TimeSetter
